import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getAuthToken } from '../../utils/utils';
import apiTokenService from './apitoken.service';

const initialState = {
  loading: false,
  success: false,
  error: null,
};

export const addApiToken = createAsyncThunk(
  'apitoken/addApiToken',
  async (payload, thunkAPI) => {
    const {
      auth: { user },
    } = thunkAPI.getState('auth');
    payload._id = user._id;
    const config = {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    };
    try {
      const res = await apiTokenService.addApiToken({ ...payload, config });
      if (res.data.status === 0) {
        toast.error('Send all necessary fields');
      }
      return res.data;
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

const apiTokenSlice = createSlice({
  name: 'apiToken',
  initialState,
  reducers: {},
  extraReducers: {
    [addApiToken.pending]: (state) => {
      state.loading = true;
    },
    [addApiToken.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
    },
    [addApiToken.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
  },
});

export default apiTokenSlice.reducer;
